(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('panda-mobile-store-switch')) {
    customElements.define('panda-mobile-store-switch', class extends HTMLElement {
      connectedCallback() {
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const details = this.querySelector('details');
        const summary = this.querySelector('summary');
        if (!details || !summary) return;
        document.addEventListener('pointerdown', (event) => {
          if (details.open && !this.contains(event.target)) details.open = false;
        }, options);
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            const hadFocus = this.contains(document.activeElement);
            details.open = false;
            if (hadFocus) summary.focus();
          }
        }, options);
        this.addEventListener('focusout', (event) => {
          if (details.open && !this.contains(event.relatedTarget)) details.open = false;
        }, options);
        this.addEventListener('click', (event) => {
          if (event.target.closest('a')) details.open = false;
        }, options);
        matchMedia('(max-width: 749px)').addEventListener('change', () => {
          details.open = false;
        }, options);
      }

      disconnectedCallback() {
        this.events?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
